import { type ReactNode, useState } from 'react';

import { Collapsible } from '../../core/collapsible/Collapsible';
import { IconChevronDownSmall } from '../../core/icons';

export type ThoughtMarkerProps = {
    readonly children: ReactNode;
    readonly label?: string;
    readonly defaultOpen?: boolean;
    readonly timestamp?: number;
    readonly timeFormatter?: Intl.DateTimeFormat;
};

export function ThoughtMarker({
    children,
    label = 'Thinking',
    defaultOpen = false,
    timestamp,
    timeFormatter,
}: ThoughtMarkerProps) {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <div className="group flex w-full flex-col items-start">
            <Collapsible open={open} onOpenChange={setOpen}>
                <Collapsible.Trigger asChild={true}>
                    <button
                        type="button"
                        className="flex items-center gap-[6px] rounded-l border-0 bg-transparent px-s py-xxs text-[13px] text-black-900 transition duration-200 hover:bg-gray-100"
                    >
                        <IconChevronDownSmall
                            style={{
                                width: 14,
                                height: 14,
                                transform: open ? 'rotate(0deg)' : 'rotate(-90deg)',
                                transition: 'transform 200ms ease',
                            }}
                        />
                        {label}
                    </button>
                </Collapsible.Trigger>
                <Collapsible.Content>
                    <div className="w-full pl-[18px] pt-xxs">{children}</div>
                </Collapsible.Content>
            </Collapsible>
            {timestamp !== undefined && timeFormatter && (
                <p className="m-0 mt-xxs pl-s text-[11px] text-gray-600 opacity-0 transition-opacity duration-150 group-hover:opacity-100">
                    {timeFormatter.format(new Date(timestamp))}
                </p>
            )}
        </div>
    );
}
